module.exports = __webpack_public_path__ + "img/icon-preview.e578c010.png";